import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en.json";
import frTranslation from "./locales/fr.json";

// Language priority: saved manual choice > browser language (fr → fr, otherwise en) > English
const storedLanguage = localStorage.getItem('selectedLanguage');
const browserLanguage = (typeof navigator !== 'undefined' && (navigator.language || (navigator.languages && navigator.languages[0])) || 'en')
  .toLowerCase()
  .startsWith('fr')
  ? 'fr'
  : 'en';
const selectedLanguage = storedLanguage || browserLanguage;

// Keep the <html lang> attribute in sync with the active language (a11y / SEO)
const syncHtmlLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
};

// Initialize i18next
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    fr: { translation: frTranslation }
  },
  lng: selectedLanguage, // Default language
  fallbackLng: "en", // Fallback language
  interpolation: {
    escapeValue: false
  }
});

syncHtmlLang(selectedLanguage);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
